import { render } from "./paymentTypeImage.vue?vue&type=template&id=0462f357&scoped=true&ts=true"
import script from "./paymentTypeImage.vue?vue&type=script&lang=ts"
export * from "./paymentTypeImage.vue?vue&type=script&lang=ts"

import "./paymentTypeImage.vue?vue&type=style&index=0&id=0462f357&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0462f357"]])

export default __exports__